import { AppProvider } from './AppContext';
import { ConsentProvider } from './ConsentContext';
import { OnboardingProvider } from './OnboardingContext';

const ContextProvider = ({ children }) => {
  return (
    <AppProvider>
      <OnboardingProvider>
        <ConsentProvider>{children}</ConsentProvider>
      </OnboardingProvider>
    </AppProvider>
  );
};

export default ContextProvider;
